/* eslint-disable react/prop-types */
import React from "react"
import * as Sentry from "@sentry/react"
import { graphql } from "@apollo/client/react/hoc"
import { compose, withProps } from "recompose"
import { useRouteMatch } from "react-router-dom"
import gql from "graphql-tag"
import Header from "."

let userSet = false

// Add user context for analytics.
/* istanbul ignore next */
const initFullStory = (user) => {
  if (window["FS"]) {
    window["FS"].setUserVars({
      uid: user.id,
      displayName: `${user.firstName} ${user.lastName}`,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      healthcareRole: user.healthcareRole,
      departmentId: user.department.id,
      departmentName: user.department.name,
      facilityId: user.facility.id,
      facilityName: user.facility.name,
    })
  }
}

const HeaderEnhanced = compose(
  withProps(() => {
    const match = useRouteMatch({ path: "/facility/:facilityId" })
    return {
      facilityId: match?.params?.facilityId,
    }
  }),
  (component) => (props) => {
    const facilitySubQuery = `
      facility(id: $facilityId) {
        id
        name
      }
    `

    const query = gql`
      query ContactTracingHeader${
        props.facilityId ? "($facilityId: ID!)" : ""
      } {
        user {
          id
          firstName
          lastName
          email
          healthcareRole
          department {
            id
            name
          }
          facility {
            id
            name
          }
          applications {
            name
            url
          }
        }
        ${props.facilityId ? facilitySubQuery : ""}
      }
    `

    return React.createElement(
      graphql(query, {
        options: ({ facilityId }) => ({
          variables: {
            facilityId,
          },
        }),
        props: ({ data: { error, loading, user, facility } }) => {
          if (error || loading) return {}
          if (!userSet) {
            initFullStory(user)
            /* istanbul ignore next */
            if (window.hj) {
              window.hj("identify", user.id, { facility: user.facility.name })
            }
            userSet = true
            Sentry.setUser({ id: user.id })
          }

          return {
            userId: user.id,
            initials: `${user.firstName[0]}${user.lastName[0]}`,
            facilityName: facility && facility.name,
            userNavLinks: [
              ...user.applications.map((app) => (
                <a key={app.url} href={app.url}>
                  {app.name}
                </a>
              )),
              <a
                key="/users/settings"
                href={process.env.REACT_APP_AUTH_DOMAIN + "/users/settings"}
              >
                Change Password
              </a>,
              <a
                key="/users/sign_out"
                href={process.env.REACT_APP_AUTH_DOMAIN + "/users/sign_out"}
              >
                Log Out
              </a>,
            ],
          }
        },
      })(component),
      props
    )
  }
)(Header)

export default HeaderEnhanced
